import { createFileRoute, Link } from "@tanstack/react-router";

import { AppShell } from "@/components/AppShell";
import { FeatureGate } from "@/components/UpgradeGate";
import { PriceBookPanel } from "@/components/pricebook/PriceBookPanel";

export const Route = createFileRoute("/_authenticated/visuals/price-book")({
  head: () => ({
    meta: [
      { title: "Price book — MyPriorities" },
      {
        name: "description",
        content:
          "Build a reusable catalogue of products and services with cost variables and commercial pricing drivers, then price any business case from it.",
      },
      { property: "og:title", content: "Price book — MyPriorities" },
      {
        property: "og:description",
        content:
          "Products, cost variables and commercial drivers that feed straight into your business cases.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: PriceBookRoute,
});

function PriceBookRoute() {
  return (
    <FeatureGate
      requires="pro"
      title="Price book"
      subtitle="Products and services with cost variables and commercial drivers, ready to price a business case."
    >
      <AppShell
        title="Price book"
        subtitle="Products and services with cost variables and commercial drivers, ready to price a business case."
      >
        <p className="mb-6 text-sm text-muted-foreground">
          Add lines from this catalogue inside the{" "}
          <Link
            to="/visuals/business-case"
            className="text-primary underline-offset-4 hover:underline"
          >
            business case builder
          </Link>
          .
        </p>
        <PriceBookPanel />
      </AppShell>
    </FeatureGate>
  );
}
